import { DietFoodTypeId, DietFoodType } from 'app/dataTypes/org/dietFoodTypes'
import { DietFoodItem } from './DietFoodItem'
import EmptyWarn from 'app/common/layouts/EmptyWarn'
import styles from './DietFoodList.module.scss'

interface Props {
  dietFoodTypes: Array<DietFoodType>
  disabled: boolean
  onDelete: (id: DietFoodTypeId) => Promise<boolean>
}
export const DietFoodList = ({ dietFoodTypes, onDelete, disabled }: Props) => {
  return (
    <div className={styles.container}>
      {dietFoodTypes.length ? (
        <ul className={styles.list}>
          {dietFoodTypes.map(item => (
            <li key={item.id} className={styles.listItem}>
              <DietFoodItem
                item={item}
                onDelete={onDelete}
                disabled={disabled}
              />
            </li>
          ))}
        </ul>
      ) : (
        <div className={styles.empty}>
          <EmptyWarn>{'Включите нужные виды диетического питания из общего списка'}</EmptyWarn>
        </div>
      )}
    </div>
  )
}
